module.exports = __webpack_public_path__ + "img/watches_sidebar_ad.7d48cfa5.jpg";